import { render, staticRenderFns } from "./ReturnPermit.vue?vue&type=template&id=2073c9c0&"
import script from "./ReturnPermit.vue?vue&type=script&lang=ts&"
export * from "./ReturnPermit.vue?vue&type=script&lang=ts&"
import style0 from "./ReturnPermit.vue?vue&type=style&index=0&id=2073c9c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports